<template>
  <div :class="['masthead', {'has-video': !!video}]" :style="{'background-image': 'url('+bg+')'}">
    <video-js :media="video" :autoplay="true" :muted="true" :chromeless="true" :banner="true" v-if="video" @loadeddata="toggleBody(true)" class="banner-video" />
    <img :src="bg" class="banner-image">
    <transition>
      <div class="body" v-show="showBody">
        <container>
          <slot></slot>
        </container>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'BlastStudentMasthead',
    props: {
      bg: {
        type: String
      },
      video: {
        type: Object
      }
    },
    data () {
      return {
        showBody: !this.video
      }
    },
    methods: {
      toggleBody (state) {
        this.showBody = state
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  .masthead {
    @include font-size(medium);
    color:$color-black; background:center; background-size:cover; position:relative; padding-bottom:0rem; overflow:hidden;
    @include media(small,xlarge) {
      background:none !important;
    }
    @include media(xlarge) {
      height:calc(50vh - #{$header-height}); display:flex; align-items:flex-end; text-align:center; margin-bottom:-6rem;
    }
    @include media(xxlarge) {
      height:calc(70vh - #{$header-height});
    }
    &.has-video {
      @include media(xlarge) {
        background:none !important;
      }
    }
    /deep/ {
      h1 {
        @include font-size(xxlarge, $headline:true)
        margin-bottom:1rem;
      }
      h2 {
        @include font-size(xlarge, $headline:true)
        @include media(small, xlarge) {
          margin-top:1rem;
        }
      }
      h1,h2 {
        max-width:1100px; margin:0 auto;
      }
      .date {
        margin:0 0 .25rem;
      }
      .blast-labels {
        margin-top: 0.25rem;
        @include media(xlarge) {
          justify-content: center;
        }
      }
      svg {
        @include media(xlarge) {
          fill:#fff;
        }
      }
    }
    @media print {
      padding-top: 2rem; padding-bottom: 0; height:auto; background-image:none !important;
    }
  }

  .body {
    &.v-enter {
      opacity:0;
    }
    @include media(small,xlarge) {
      display:block !important; text-align:left;
    }
    @include media(xlarge) {
      @include transition();
      width:100%; position:relative; z-index:3; padding:8.5rem 2rem; background:linear-gradient(rgba($color-primary-darker, 0), rgba($color-primary-darker, .9)); color:$color-white;
    }
  }

  .banner-video {
    @include media(small,xlarge) {
      display:none !important;
    }
  }

  .banner-image {
    margin-bottom:3rem;
    @include media(xlarge) {
      display:none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BlastStudent/Masthead.vue